var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"w-tabs-centered"},_vm._l((_vm.renderedItems),function(tab){return _c('w-tab',{key:tab.key,attrs:{"active":tab.value == _vm.value},on:{"click":function($event){return _vm.tabClicked(tab)}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(tab.text)+" ")]},{"tab":tab})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }